<template>
    <div
        class  = "order-column"
        :class = "unit.header || unit.lastInGroup ? 'unit-header-divider' : ''"
    >
        <div v-if="unit.header" class="primary--text">
            {{ unit.order.customer }}
        </div>
        <div  v-if="unit.header" class="secondary--text" style="font-size: 12px;margin-top: -2px;">
            {{ orders }}
        </div>
    </div>
</template>

<script>
export default {
    name: "PDispositionOrderDetails",

    props: {
        unit: {

        }
    },

    computed: {
        orders () {
            if (!this.unit.orderList || this.unit.orderList.length === 0) {
                return this.unit.order.no;
            }

            let result = "";
            this.unit.orderList.forEach(o => {
                result += o.no + " "
            })

            return result
        }
    }
}
</script>

<style scoped>

.order-column {
    font-size: 15px;
    width: 50%;
    padding-top: 2px;
    padding-left: 8px;
}

</style>